import { Dialog } from "@mui/material";
import { ComponentType, PropsWithChildren, useEffect, useState } from "react";

type CloseableModalProps = {
  handleRemove: () => void;
}

export type CloseableModalComponentType = ComponentType<CloseableModalProps>;

export const CloseableModal = ({ children, handleRemove }: PropsWithChildren<CloseableModalProps>) => {
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    setShow(true);
  }, []);

  const handleClose = () => {
    // Account for onExited firing when fade-out animation starts, not when it ends
    handleRemove();
    setShow(false);
  };

  return (
    <Dialog open={show} onClose={handleClose}>
      {children}
    </Dialog>
  );
};
